import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { takeoverChannel } from '../api/client.js';

import { useMyPartyInvalidation } from './useMyPartyInvalidation.js';

import type {
  ChannelId,
  JoinPartyResponse,
  PartySlug,
  TakeoverChannelRequest,
} from '@mixwire/contracts';

type TakeoverVariables = {
  readonly slug: PartySlug;
  readonly channelId: ChannelId;
} & TakeoverChannelRequest;

export const useTakeoverChannel = (): UseMutationResult<
  JoinPartyResponse,
  Error,
  TakeoverVariables
> => {
  const invalidateMyParty = useMyPartyInvalidation();

  return useMutation({
    mutationFn: async ({ slug, channelId, displayName }: TakeoverVariables) =>
      takeoverChannel(slug, channelId, { displayName }),
    onSuccess: invalidateMyParty,
  });
};
